import { tokenAxios } from "@/utils/axios";
import { useQuery } from "@tanstack/react-query";
import { TaoProvidersArgs, TaoProvidersResponse } from "@/types/tao-routing";
import { useAppState } from "@/contexts/app-state";
import { buildApiUrl } from "@/utils/api";

const getTaoProviders = async (params: TaoProvidersArgs) => {
  // @eslint-disable-line
  const { data } = await tokenAxios().get<TaoProvidersResponse>(buildApiUrl("providersByPracticeId"), { params });
  return data;
};

export const useTaoProviders = () => {
  const { context, loggedInUser } = useAppState();
  const practiceId = context?.athena?.practiceId ?? "8967";
  const requestedUser = loggedInUser;

  return useQuery<TaoProvidersResponse, Error>({
    queryKey: ["Tao-Routing-Providers", practiceId, requestedUser],
    queryFn: () => getTaoProviders({ practiceId, requestedUser }),
  });
};
